import { CurrencyPipe, isPlatformBrowser, NgIf } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';
import { FuseAlertType } from '@fuse/components/alert';
import { FuseCardComponent } from '@fuse/components/card';
import { CustomerService } from 'app/core/shared-services/customer.service';
import { ICustomer } from 'app/core/shared-services/shared-interface.types';
import { SharedMethodsModule } from 'app/core/shared-services/shared-methods.module';
import { WebStorage } from 'app/core/shared-services/web.storage';

@Component({
  selector: 'app-outstanding',
  standalone: true,
  imports: [MatButtonModule, MatInputModule, NgIf, MatIconModule, FuseCardComponent, CurrencyPipe, MatProgressSpinnerModule, RouterLink],
  templateUrl: './outstanding.component.html',
  styleUrl: './outstanding.component.scss'
})
export class OutstandingComponent implements OnInit {

  private customer: ICustomer;

  public customerBalanceResult: any;
  public customerBalance: number;
  public accountInArrears: boolean = false;
  public payOwnAmount: number;

  private payNowResult: any;
  public alert: { type: FuseAlertType; message: string };
  public showAlert: boolean = false;

  public loading: boolean = false;
  public disableButton: boolean = false;

  constructor(
    private _webStorage: WebStorage,
    private _customer: CustomerService,
    private _sharedMethods: SharedMethodsModule,

    
    @Inject(PLATFORM_ID) private platformId: any
  ){}

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */


  async ngOnInit() {
    // get the customer
    this._customer.customer$.subscribe({
      next: (customer: ICustomer) => {
        this.customer = customer;
        // get the customer outstanding amount
        this._webStorage.CustommerAmountOutstanding.subscribe({
          next: async (amount: number) => {
            if (amount > 0) {
              this.accountInArrears = true;
              this.customerBalance = amount;
              this.payOwnAmount = amount;
            } else {
              // make sure there is no outstanding amount
              this.customerBalanceResult = await this._sharedMethods.getCustomerBalance(this.customer.CustomerAccount?.EntityAccountEntityID);
              if (this.customerBalanceResult.result <= 0 ) {
                this.accountInArrears = false
              } else {
                this.accountInArrears = true;
                this.payOwnAmount = this.customerBalanceResult.result;
                this.customerBalance = this.customerBalanceResult.result;
              }
            }
          }
        })
      }
    })
  }

  public async payNow() {
    this.loading= true;
    const payNowData = {
      pendingAmount: this.customerBalance == this.payOwnAmount ? this.customerBalance : this.payOwnAmount,
      isPartialPayment: this.customerBalance == this.payOwnAmount ? false : true,
      isForCardTokenisation: false
    }
    this.payNowResult = await this._sharedMethods.payNow(payNowData);

    if (this.payNowResult?.success && isPlatformBrowser(this.platformId)) {
      // only using payfast for now
      window.open(this.payNowResult.result[0].PaymentLink, '_top');
    } else {
      this.alert = {
        type: 'error',
        message: this.payNowResult?.error?.error?.Message,
      }
      this.showAlert = true;
    }

  }

  public ownAmount(amount: any) {
    let value = amount.target.value
    if (value.includes('-')) {
      this.disableButton = true;
    } else {
      this.payOwnAmount = amount.target.value;
    }
  }

}
